import { DeviceConfigRequestStatus } from '../../devices/constants/devices.constants';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { RequestStatus } from '@ui/aos-lib';

export const commandStatusLabelMap: Partial<Record<DeviceConfigRequestStatus, string>> = {
  [DeviceConfigRequestStatus.COMPLETED]: TranslateRegistry.get.FILTER.COMMAND_STATUS.COMPLETED,
  [DeviceConfigRequestStatus.REGISTERED]: TranslateRegistry.get.FILTER.COMMAND_STATUS.REGISTERED,
  [DeviceConfigRequestStatus.SCHEDULED]: TranslateRegistry.get.FILTER.COMMAND_STATUS.SCHEDULED,
  [DeviceConfigRequestStatus.IN_PROGRESS]: TranslateRegistry.get.FILTER.COMMAND_STATUS.INPROGRESS,
  [DeviceConfigRequestStatus.IN_QUEUE]: TranslateRegistry.get.FILTER.COMMAND_STATUS.INQUEUE,
  [DeviceConfigRequestStatus.ONHOLD]: TranslateRegistry.get.FILTER.COMMAND_STATUS.ONHOLD,
  [DeviceConfigRequestStatus.HEADEND_ACKNOWLEDGED]: TranslateRegistry.get.FILTER.COMMAND_STATUS.HEADEND_ACKNOWLEDGED,
  [DeviceConfigRequestStatus.HEADEND_VERIFIED]: TranslateRegistry.get.FILTER.COMMAND_STATUS.HEADEND_VERIFIED,
  [DeviceConfigRequestStatus.EXPIRED]: TranslateRegistry.get.FILTER.COMMAND_STATUS.EXPIRED,
  [DeviceConfigRequestStatus.FAILED]: TranslateRegistry.get.FILTER.COMMAND_STATUS.FAILED,
  [DeviceConfigRequestStatus.TIME_OUT]: TranslateRegistry.get.FILTER.COMMAND_STATUS.TIMEOUT,
  [DeviceConfigRequestStatus.ERROR]: TranslateRegistry.get.FILTER.COMMAND_STATUS.ERROR,
  [DeviceConfigRequestStatus.CANCELED]: TranslateRegistry.get.FILTER.COMMAND_STATUS.CANCELED
};

export const commandStatusTooltipMap: Partial<Record<DeviceConfigRequestStatus, string>> = {
  [DeviceConfigRequestStatus.COMPLETED]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_COMPLETED,
  [DeviceConfigRequestStatus.REGISTERED]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_REGISTERED,
  [DeviceConfigRequestStatus.SCHEDULED]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_SCHEDULED,
  [DeviceConfigRequestStatus.IN_PROGRESS]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_INPROGRESS,
  [DeviceConfigRequestStatus.IN_QUEUE]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_INQUEUE,
  [DeviceConfigRequestStatus.ONHOLD]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_ONHOLD,
  [DeviceConfigRequestStatus.HEADEND_ACKNOWLEDGED]:
    TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_HEADEND_ACKNOWLEDGED,
  [DeviceConfigRequestStatus.HEADEND_VERIFIED]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_HEADEND_VERIFIED,
  [DeviceConfigRequestStatus.EXPIRED]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_EXPIRED,
  [DeviceConfigRequestStatus.FAILED]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_FAILED,
  [DeviceConfigRequestStatus.TIME_OUT]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_TIMEOUT,
  [DeviceConfigRequestStatus.ERROR]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_ERROR,
  [DeviceConfigRequestStatus.CANCELED]: TranslateRegistry.get.TOOLTIP.TEXT.COMMAND_STATUS_CANCELED
};

export const commandStatusBubbleMap: Partial<Record<DeviceConfigRequestStatus, RequestStatus>> = {
  [DeviceConfigRequestStatus.COMPLETED]: RequestStatus.Completed,
  [DeviceConfigRequestStatus.SCHEDULED]: RequestStatus.Scheduled,
  [DeviceConfigRequestStatus.REGISTERED]: RequestStatus.Registered,
  [DeviceConfigRequestStatus.HEADEND_ACKNOWLEDGED]: RequestStatus.HeadendAcknowledged,
  [DeviceConfigRequestStatus.IN_QUEUE]: RequestStatus.InQueue,
  [DeviceConfigRequestStatus.ONHOLD]: RequestStatus.OnHold,
  [DeviceConfigRequestStatus.IN_PROGRESS]: RequestStatus.InProgress,
  [DeviceConfigRequestStatus.HEADEND_VERIFIED]: RequestStatus.HeadendVerified,
  [DeviceConfigRequestStatus.TIME_OUT]: RequestStatus.TimeOut,
  [DeviceConfigRequestStatus.FAILED]: RequestStatus.Failed,
  [DeviceConfigRequestStatus.ERROR]: RequestStatus.Error,
  [DeviceConfigRequestStatus.EXPIRED]: RequestStatus.Expired,
  [DeviceConfigRequestStatus.CANCELED]: RequestStatus.Canceled
};
